export const statusStyles = {
  Paid: 'good',
  ReviewCompleted: 'good',
  PaymentPending: 'bad',
  ReviewPending: 'badish',
  PaymentFailed: 'bad',
  MonthInProgress: 'none',
  MonthSkipped: 'none',
  PaidPartially: 'bad',
  PaymentOverdue: 'bad',
  ReadyToReconcile: 'exciting'
}

export const statusNames = {
  Paid: 'Paid',
  PaidPartially: 'Partially paid',
  PaymentPending: 'Payment pending',
  ReviewPending: 'Review pending',
  ReviewCompleted: 'Ready to pay',
  PaymentFailed: 'Payment failed',
  PaymentOverdue: 'Payment overdue',
  MonthInProgress: 'Month in progress',
  MonthSkipped: 'Month skipped'
}

export const invoiceStatusesAcceptableForTotalDueCalculation = [
  'PaidPartially',
  'PaymentFailed',
  'PaymentOverdue',
  'PaymentPending'
]

export const invoiceStatusesAcceptableForBalanceCalculation = [
  'PaidPartially',
  'PaymentFailed',
  'PaymentOverdue',
  'PaymentPending',
  'ReviewCompleted'
]

export const adminStatusNames = {
  ...statusNames,
  ReviewCompleted: 'Review completed'
}
